import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

interface IDateInputProps {
    label?: string;
    value?: moment.Moment | Date | string | null;
    onChange: (time: moment.Moment | null, value?: string | null) => void;
    minDate?: Date;
    maxDate?: Date;
}

export default function DateInput({ label, value, onChange, minDate, maxDate }: IDateInputProps) {
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
                label={label}
                format="MM/DD/YYYY"
                value={value ? moment(value) : null}
                onChange={(newValue: moment.Moment | Date | null) => onChange(newValue ? moment(newValue) : null)}
                openTo="day"
                minDate={minDate ? moment(minDate) : undefined}
                maxDate={maxDate ? moment(maxDate) : undefined}
                slotProps={{
                    textField: {
                        variant: 'standard',
                        style: { maxWidth: 150 },
                    },
                }}
            />
        </LocalizationProvider>
    );
}
